import React from 'react';

const statusConfig = {
  new: {
    label: 'New',
    color: 'var(--color-info)',
    bg: 'var(--color-info-bg)',
  },
  active: {
    label: 'Active',
    color: 'var(--color-success)',
    bg: 'var(--color-success-bg)',
  },
  more_evidence_needed: {
    label: 'More Evidence',
    color: 'var(--color-warning)',
    bg: 'var(--color-warning-bg)',
  },
  under_consideration: {
    label: 'Considering',
    color: 'var(--color-ai)',
    bg: 'rgba(124, 58, 237, 0.12)',
  },
  in_progress: {
    label: 'In Progress',
    color: 'var(--coros-red)',
    bg: 'var(--coros-red-light)',
  },
  acknowledged: {
    label: 'Acknowledged',
    color: 'var(--text-muted)',
    bg: 'var(--bg-tertiary)',
  },
  shipped: {
    label: 'Shipped',
    color: 'var(--color-success)',
    bg: 'var(--color-success-bg)',
  },
  denied: {
    label: 'Denied',
    color: 'var(--color-error)',
    bg: 'var(--color-error-bg)',
  },
};

export function StatusBadge({ status, showDot = true, size = 'sm' }) {
  const config = statusConfig[status] || statusConfig.new;

  const sizes = {
    xs: { padding: '2px 8px', fontSize: 10 },
    sm: { padding: '2px 10px', fontSize: 11 },
    md: { padding: '3px 12px', fontSize: 12 },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: s.padding,
      fontSize: s.fontSize,
      fontWeight: 600,
      color: config.color,
      background: config.bg,
      borderRadius: 99,
    }}>
      {showDot && (
        <span style={{
          width: 5, height: 5,
          borderRadius: '50%',
          background: config.color,
          flexShrink: 0,
        }} />
      )}
      {config.label}
    </span>
  );
}

export default StatusBadge;
